import { environment } from "./config";

export const featureFlags = {
    newFeatureRequest: environment !== "production",
};
